import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["totalResults", "showFilterGroupName", "showResultsCount", "renderResultsLabel", "showSortTrigger", "showOnlyTrigger"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// Components
import FilterTrigger from '../filterTrigger';
import FilterGroupName from '../../atoms/filterGroupName';
import FilterResults from '../../atoms/filterResults';
import FilterDialog from '../../filterDialog';
import PropertyControlledComponent from '../../../../molecules/PropertyControlledComponent';
import MultiSortTrigger from '../../../MultiSort/components/MultiSortTrigger';

// Helpers
import { getSelectedFilterGroup } from './filterGroupToolbar.helpers';

// Readers
import filterGroupReader from '../../readers/FilterGroup';

// Styles
import s from './filterGroupToolbar.module.scss';
var FilterGroupToolbar = /*#__PURE__*/function (_Component) {
  _inherits(FilterGroupToolbar, _Component);
  var _super = _createSuper(FilterGroupToolbar);
  function FilterGroupToolbar() {
    var _this;
    _classCallCheck(this, FilterGroupToolbar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "renderSortButton", function () {
      var _this$props = _this.props,
        onSortApply = _this$props.onSortApply,
        columns = _this$props.columns,
        sortDetails = _this$props.sortDetails,
        assetType = _this$props.assetType,
        applyInitSort = _this$props.applyInitSort,
        allColumns = _this$props.allColumns,
        showFilterTrigger = _this$props.showFilterTrigger;
      return /*#__PURE__*/React.createElement(MultiSortTrigger, {
        applyInitSort: applyInitSort,
        allColumns: allColumns,
        columns: columns,
        sortDetails: sortDetails,
        onSortApply: onSortApply,
        assetType: assetType,
        classNames: cx(_defineProperty({}, s.clearLeftMargin, !showFilterTrigger))
      });
    });
    return _this;
  }
  _createClass(FilterGroupToolbar, [{
    key: "getFilterGroupName",
    value: function getFilterGroupName() {
      var _this$props2 = this.props,
        appliedFilterGroup = _this$props2.appliedFilterGroup,
        filterGroups = _this$props2.filterGroups;
      var filterGroup = getSelectedFilterGroup(appliedFilterGroup, filterGroups);
      return filterGroupReader.name(filterGroup);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        totalResults = _this$props3.totalResults,
        showFilterGroupName = _this$props3.showFilterGroupName,
        showResultsCount = _this$props3.showResultsCount,
        renderResultsLabel = _this$props3.renderResultsLabel,
        showSortTrigger = _this$props3.showSortTrigger,
        showOnlyTrigger = _this$props3.showOnlyTrigger,
        filterDialogProps = _objectWithoutProperties(_this$props3, _excluded);
      var filterGroupName = this.getFilterGroupName();
      return /*#__PURE__*/React.createElement("div", {
        className: s.container
      }, /*#__PURE__*/React.createElement(FilterTrigger, filterDialogProps), !showOnlyTrigger && showFilterGroupName && /*#__PURE__*/React.createElement(FilterGroupName, {
        filterGroup: filterGroupName
      }), !showOnlyTrigger && showResultsCount && /*#__PURE__*/React.createElement(FilterResults, {
        resultsCount: totalResults,
        className: cx(_defineProperty({}, s.filterResult, !filterGroupName)),
        renderResultsLabel: renderResultsLabel
      }), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
        controllerProperty: showSortTrigger
      }, this.renderSortButton()));
    }
  }]);
  return FilterGroupToolbar;
}(Component);
FilterGroupToolbar.propTypes = _objectSpread(_objectSpread({}, FilterDialog.propTypes), {}, {
  totalResults: PropTypes.number,
  showFilterGroupName: PropTypes.bool,
  showResultsCount: PropTypes.bool,
  showOnlyTrigger: PropTypes.bool,
  renderResultsLabel: PropTypes.func
});
FilterGroupToolbar.defaultProps = _objectSpread(_objectSpread({}, FilterDialog.defaultProps), {}, {
  totalResults: 0,
  showFilterGroupName: true,
  showFilterResults: true,
  showResultsCount: true,
  showOnlyTrigger: false,
  renderResultsLabel: undefined
});
export default FilterGroupToolbar;